import placeholder from "@/assets/img/placeholder.webp";

export default function getImagePath(path, resource, id, quality = null) {
    if (path) {
        const imagePath = quality ? `${quality}-${path}` : path;
        return `${SERVER}/uploads/${resource}/${id}/images/${imagePath}`;
    } else {
        return placeholder;
    }
};